module.exports = __webpack_public_path__ + "09_mole.d908f456.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/09_mole.png
// module id = 8zDG
// module chunks = 0